<div id="config-delete-user-container" *ngIf="this.value">
  <p class="heading-02-semi-bold">
    ¿Está seguro que desea eliminar el usuario
    <span class="heading-02-bold"
      >{{ this.value.name }} {{ this.value.lastname }}</span
    >
    ?
  </p>
  <div id="check-container">
    <mat-checkbox color="primary" (change)="checkDisabled($event.checked)">
    </mat-checkbox>
    <p class="subheading-01-semi-bold">
      Comprendo que eliminar el usuario es una acción irreversible
    </p>
  </div>
</div>
